<template>
  <el-container class="stui-content" style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;">
      <el-col :span="8">
        <el-select v-model="value"  filterable placeholder="请选择" @change="onChangeStripe">
            <el-option
              v-for="item in options"
              :key="item.week"
              :label="item.week"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="qipaoId"  filterable placeholder="请选择" @change="onChangeStripe">
              <el-option
                v-for="item in qipao"
                :key="item.name"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
      </el-col>

      <el-col :span="18" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 80%;margin-top: 10px;">


        <el-row  class="tui-el">
          <el-col :span="4" style="text-align: center;">指令</el-col>
          <el-col :span="4" style="text-align: center;">气泡图</el-col>
          <el-col :span="6" style="text-align: center;">开始时间</el-col>
          <el-col :span="6" style="text-align: center;">结束时间</el-col>
          <el-col :span="4" style="text-align: center;">操作</el-col>
        </el-row>
        <el-row  class="tui-el" style="margin-top: 15px;">
          <el-col :span="4" style="text-align: center;line-height: 60px;"><input type="text" style="width: 180px;height: 30px;" v-model="zhiLing" @change="onImage()"></el-col>
          <el-col :span="4" style="text-align: center;">
            <img v-if="newImage" :src="newImage" class="avatar" style="margin-left: 110px;">

            <input v-else type="text" style="width: 180px;height: 30px;margin-top: 10px;" v-model="newName" @change="onImage()">
          </el-col>

          <el-col :span="6" style="text-align: center;">
            <el-time-select
              style="margin-bottom: -1px;margin-right: -21px;"
              v-model="time1"
              :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00'
              }"
              placeholder="选择时间">
            </el-time-select>
          </el-col>
          <el-col :span="6" style="text-align: center;">
            <el-time-select
              v-model="time2"
              :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00'
              }"
              placeholder="选择时间">
            </el-time-select>
          </el-col>
          <el-col :span="4" ><input type="button" style="position: absolute;right: 120px;top: 15px;" @click="add()" value="添加"></el-col>
        </el-row>
        <el-row  class="tui-el" v-for="(item,index) in list" :key="index">
          <el-col :span="4" style="text-align: center;line-height: 60px;" @click.native="changeTui(item.id,item.name,item.time1,item.time2)">{{item.name}}</el-col>
          <el-col :span="4" style="text-align: center;">
            <img style="margin-left: 110px;width: 80px;height: 80px;" v-if="item.img" :src="item.img" class="avatar">

          </el-col>
          <el-col :span="6" style="text-align: center;line-height: 60px;">{{item.time1}}</el-col>
          <el-col :span="6" style="text-align: center;line-height: 60px;">{{item.time2}}</el-col>

          <el-col :span="4" style="text-align: center;line-height: 60px;" @click.native="del(item.id,index)">删除</el-col>
        </el-row>
      </el-col>


    </el-row>
    <el-dialog
      title="排序"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text"  class="searchTsx" v-model="addSort"/>

      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dosort()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="changeVisible"
      width="70%"
      >
      <el-row  class="tui-el" style="margin-top: 15px;">
        <el-col :span="6" style="text-align: center;line-height: 60px;margin-bottom: 30px;"><input type="text" style="width: 180px;height: 30px;" v-model="tname"></el-col>
        <el-col :span="6" style="text-align: center;">
          <img v-if="newImage1" :src="newImage1" class="avatar" style="margin-left: 110px;">

          <input v-else type="text" style="width: 100px;height: 30px;margin-top: 10px;margin-bottom: 30px;" v-model="newName1" @change="onImage1()">
        </el-col>

        <el-col :span="6" style="text-align: center;">
          <el-time-select
            style="margin-bottom: -1px;margin-right: -21px;"
            v-model="time3"
            :picker-options="{
              start: '00:00',
              step: '00:01',
              end: '24:00'
            }"
            placeholder="选择时间">
          </el-time-select>
        </el-col>
        <el-col :span="6" style="text-align: center;">
          <el-time-select
            v-model="time4"
            :picker-options="{
              start: '00:00',
              step: '00:01',
              end: '24:00'
            }"
            placeholder="选择时间">
          </el-time-select>
        </el-col>

      </el-row>
    	<el-button @click="changeVisible = false" style="margin-left: 40%;">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        options: [{week:'周一',id:1},{week:'周二',id:2},{week:'周三',id:3},{week:'周四',id:4},{week:'周五',id:5},{week:'周六',id:6},{week:'周日',id:0}],
        qipao: [{name:'1号气泡',id:1},{name:'2号气泡',id:2},{name:'3号气泡',id:3},{name:'4号气泡',id:4},{name:'5号气泡',id:5},{name:'6号气泡',id:6},{name:'7号气泡',id:7},
                  {name:'8号气泡',id:8},{name:'9号气泡',id:9},{name:'10号气泡',id:10},{name:'11号气泡',id:11},{name:'12号气泡',id:12},{name:'13号气泡',id:13},{name:'14号气泡',id:14},{name:'15号气泡',id:15},
                  {name:'16号气泡',id:16},{name:'17号气泡',id:17},{name:'18号气泡',id:18},{name:'19号气泡',id:19},{name:'20号气泡',id:20},{name:'21号气泡',id:21},{name:'22号气泡',id:22},
                  {name:'23号气泡',id:23},{name:'24号气泡',id:24},{name:'25号气泡',id:25},{name:'26号气泡',id:26},{name:'27号气泡',id:27},{name:'28号气泡',id:28},{name:'29号气泡',id:29},{name:'30号气泡',id:30},
                  {name:'31号气泡',id:31},{name:'32号气泡',id:32},{name:'33号气泡',id:33}],
        delId:'',
        zhiLing:'',
        qipaoId:1,
        delIndex:'',
        addSort:0,
        dialogVisible:false,
        centerDialogVisible:false,
        changeVisible:false,
        paiId:0,
        value: 1,
        valueName:'周一',
        qipaoName:'1号气泡',
        addImg:'',
        addImgs:'',
        newName:'',
        newImage:'',
        newName1:'',
        newImage1:'',
        tid:0,
        time1:'',
        time2:'',
        time3:'',
        time4:'',
        tname:'',
        imageId: 0,
        list: [],
        search:''

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData()

    },

	methods:{

    changeTui(id,name,time3,time4){
      this.tid = id
      this.changeVisible = true
      this.time3 = time3
      this.time4= time4
      this.tname = name
      this.newImage1 = ''
      this.newName1 = ''
    },
    onImage1(){
      if(this.newName1 == ''){
        this.newImage1 = ''
        return false
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		name:this.newName1,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/getImages'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.newImage1 = res.data.data.img
      	}else{
           this.newImage1 = ''
           alert('图片不存在，请去图库上传')
      	}
      })
      .catch(err=>{

      });
    },
    onImage(){
      if(this.newName == ''){
        this.newImage = ''
        return false
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		name:this.newName,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/getImages'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.newImage = res.data.data.img
      	}else{
           this.newImage = ''
           alert('图片不存在，请去图库上传')
      	}
      })
      .catch(err=>{

      });
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.tname == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.newImage1 == ''){
        this.msg('请选择图片','error')
        return false
      }

      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/sTuiChange',
      	params:{
          id:this.tid,
      		name:this.tname,
      		url:this.newImage1,
          week:this.value,
          time1:this.time3,
          time2:this.time4,
          s_id:this.qipaoId,
      	}
      })
      .then(res=>{
        this.changeVisible = false
        this.loadData()
      })
      .catch(err=>{

      });
    },
    UploadUrl(id){
      return "http://fencip.yoooooo.com/index.php/index/data/pythonImgChange?id="+id
    },
    onChangeStripe(){
      this.loadData()
    },
    loadData(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          week:this.value,
          s_id:this.qipaoId
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/sTuiList'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },
    loadList(){

    },
    handleAvatarSuccess1(res, file){


      this.addImg = URL.createObjectURL(file.raw);
      this.addImgs = file.response.data
      console.log(this.addImgs)
    },
    handleAvatarSuccess(res, file) {


      this.list[this.imageId]['img'] = URL.createObjectURL(file.raw);
    },
    ceshi(index){
      this.imageId = index
    },
    del(id,index){
      this.dialogVisible = true
      this.delId = id
      this.delIndex = index

    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delId,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/sTuiImgDel'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.delId = 0
           this.dialogVisible = false
           this.list.splice(this.delIndex,1)
           this.delIndex = ''
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisible = false
      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.zhiLing == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.newImage == ''){
        this.msg('请选择图片','error')
        return false
      }

      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/sTuiAdd',
      	params:{
      		name:this.zhiLing,
      		url:this.newImage,
          week:this.value,
          time1:this.time1,
          time2:this.time2,
          s_id:this.qipaoId,
      	}
      })
      .then(res=>{
      	this.tableData = res.data.data
        this.newImage = ''
        this.zhiLing = ''
        this.loadData()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .stui-content{
    margin-left: 10%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }

  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/stui.vue